import { DateTime } from 'luxon';
import { useMemo, useState } from 'react';
import { ToDate } from '@utils/DateUtils';
import { useGetScienceSomethingViewCreator } from '@viewCreators';

export const useScienceSomethingCard2Controller = (startDate: string | DateTime, groupId: number) => {
  const [open, setOpen] = useState(false);

  // enabled: !(DateTime.now() < startDate.plus({ day: 11 })),
  const message = 'Keep up the momentum—this part of the program is just around the corner.';
  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);
  if (!startDate)
    return {
      open,
      openDialog,
      closeDialog,
      disabledMessage: message,
      enabled: false,
      content: { title: '', body: '', offset: 0, duration: 0 },
      learnMoreDisabled: true,
    };
  const groupStartDate = ToDate(startDate);
  const { data } = useGetScienceSomethingViewCreator(groupStartDate, groupId);

  const enabled = useMemo(() => {
    if (!startDate) return false;
    const daysFromStart = Math.abs(groupStartDate.diffNow('days').days);
    return daysFromStart >= 11;
  }, [startDate]);

  const learnMoreDisabled: boolean = useMemo(() => {
    if (!data) return false;
    return !enabled;
  }, [data]);

  return {
    open,
    openDialog,
    closeDialog,
    disabledMessage: message,
    enabled,
    content: data?.content || { title: '', body: '', offset: 0, duration: 0 },
    learnMoreDisabled,
  };
};
